import React from "react";
import { useImpersonation } from "../../features/impersonation/hooks";

/**
 * Persistent, unmissable banner shown while a staff user is viewing the app as a
 * customer. Rendered once globally (in ProtectedRoute), in flow at the top of the
 * page, so it appears on every authenticated page regardless of that page's
 * layout and pushes content down rather than overlaying it. Reads as read-only
 * and offers a one-click exit. Renders nothing when not impersonating.
 */
export function ImpersonationBanner() {
  const { impersonationDomain, isImpersonating, stopImpersonation } =
    useImpersonation();

  if (!isImpersonating) return null;

  return (
    <div className="flex w-full shrink-0 items-center justify-center gap-3 bg-warning px-4 py-2 text-sm font-medium text-warning-solid-foreground shadow-sm">
      <span>
        Viewing as <strong>{impersonationDomain}</strong> (read-only)
      </span>
      <button
        onClick={stopImpersonation}
        className="rounded bg-warning-solid-foreground/10 px-2 py-0.5 text-xs font-semibold hover:bg-warning-solid-foreground/20"
      >
        Exit
      </button>
    </div>
  );
}
